module.exports = __webpack_public_path__ + "img/icon_map_10_off_010.306fc8de.png";